/** This file is auto-generated. Do not modify directly. */
import React from 'react';
import extendIcon from '../extendIcon';

const Edit = props => (
  <svg
    viewBox="0 0 128 128"
    width="1em"
    height="1em"
    {...props}
    cursor="pointer"
  >
    <title>{props.title || 'Rediger'}</title>
    <path d="M102.8 128H6c-3.3 0-6-2.7-6-6V25.2c0-3.3 2.7-6 6-6h48.4c3.3 0 6 2.7 6 6s-2.7 6-6 6H11.9v85h85V73.6c0-3.3 2.7-6 6-6s6 2.7 6 6V122c-.1 3.3-2.8 6-6.1 6z" />
    <path d="M126.3 15.8L112.4 1.9c-2.3-2.3-6.1-2.3-8.4 0L91.5 14.4l-.1.1-48.7 48.7c-.5.5-1 1.2-1.3 1.9L31 89.4c-1 2.2-.4 4.8 1.3 6.6 1.1 1.1 2.7 1.7 4.2 1.7.8 0 1.6-.1 2.4-.5l24.3-10.4c.7-.3 1.3-.7 1.9-1.3l61.3-61.3c2.2-2.3 2.2-6-.1-8.4zM57.4 76.3l-9.6 4.1 4.1-9.6 42.6-42.6 5.5 5.5-42.6 42.6zm48.9-48.9l-5.5-5.5 7.3-7.3 5.5 5.5-7.3 7.3z" />
  </svg>
);

export default extendIcon(Edit);
